<template>
    <div id="full">
        <base-button @click="backToOrder()" class="btn-dark">BACK</base-button>
        <base-button @click="print()" class="btn-dark">PRINT</base-button>
        <div id="report" v-html="html"></div>
    </div>
</template>
<script>
    import axios from "@/axios";
    import Utility from "@/mixins/utility/utility";
    import Util from "@/util/util";
    export default {
        name: "Hybrid",
        mixins: [Utility],
        components: {
        },
        data() {
            return {
                html: "",
            };
        },
        mounted() {
            this.getData();
        },
        computed: {
        },
        methods: {
            getData() {
                var ctx = this;
                axios({
                    url: `/api/ordertransactions/generate/form/html/${this.$route.params.id}`,
                    method: "GET",
                }).then((response) => {
                    ctx.html = response.data;
                });
            },
            backToOrder() {
                this.$router.go(-1);
            },
            print() {
                axios({
                    url: `/api/ordertransactions/generate/form/pdf/${this.$route.params.id}`,
                    method: "GET",
                    responseType: "blob", // important
                }).then((response) => {
                    Util.fileDownload(response.data, "Form 1-3a.pdf");
                });
            },
        }
    };
</script>
<style src="@/assets/css/13a.css"></style>